function wsToggle() {
  var btn = document.getElementById('wholesale-toggle');
  var panel = document.getElementById('wholesale-panel');
  var isOpen = panel.classList.contains('open');
  panel.classList.toggle('open');
  btn.setAttribute('aria-expanded', !isOpen);
}

function wsSelectPack(el) {
  document.querySelectorAll('.wholesale-pack-btn').forEach(function(b) {
    b.classList.remove('active');
  });
  el.classList.add('active');

  var qty = parseInt(el.dataset.qty) || 0;
  var price = parseInt(el.dataset.price) / 100;
  var priceFormatted = el.dataset.priceFormatted;
  var variantId = el.dataset.variantId;
  var isWholesale = el.dataset.wholesale === 'true';

  document.getElementById('wholesale-variant-id').value = variantId;
  document.getElementById('wholesale-is-wholesale').value = isWholesale;

  document.getElementById('wr-uds').textContent = qty + ' vapers';
  document.getElementById('wr-precio').textContent = priceFormatted;
  document.getElementById('wr-ud').textContent = '€' + (price / qty).toFixed(2) + '/ud';
  document.getElementById('wholesale-resumen').style.display = 'flex';

  var textarea = document.getElementById('wholesale-flavors-input');
  textarea.placeholder = 'Escribe los sabores para tu Pack ×' + qty + '. Si no indicas sabores, se enviarán variados.';

  var ahorroEl = document.getElementById('wr-ahorro');
  var discountMsg = document.getElementById('wholesale-discount-msg');
  if (isWholesale) {
    var pct = Math.round((1 - (price / qty) / 13) * 100);
    ahorroEl.textContent = '−' + pct + '% vs precio normal';
    ahorroEl.style.display = 'inline-block';
    discountMsg.style.display = 'block';
  } else {
    ahorroEl.style.display = 'none';
    discountMsg.style.display = 'none';
  }

  document.getElementById('wholesale-btn-cart').disabled = false;
}

function wsToggleFlavors(checkbox) {
  var textarea = document.getElementById('wholesale-flavors-input');
  var hidden = document.getElementById('wholesale-flavors-hidden');
  if (checkbox.checked) {
    textarea.style.display = 'block';
    hidden.disabled = true;
  } else {
    textarea.style.display = 'none';
    hidden.disabled = false;
    hidden.value = 'Variados';
    textarea.value = '';
  }
}

function wsAddToCart() {
  var variantId = document.getElementById('wholesale-variant-id').value;
  var isWholesale = document.getElementById('wholesale-is-wholesale').value === 'true';
  var chooseFlavors = document.getElementById('wholesale-choose-flavors').checked;
  var flavorsText = chooseFlavors
    ? (document.getElementById('wholesale-flavors-input').value || 'Variados')
    : 'Variados';

  if (!variantId) return;

  var btn = document.getElementById('wholesale-btn-cart');
  btn.disabled = true;
  btn.textContent = 'Añadiendo...';

  var properties = { 'Sabores mayorista': flavorsText };
  if (isWholesale) {
    properties['_no_discount'] = 'true';
  }

  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: variantId, quantity: 1, properties: properties })
  })
  .then(function(res) { return res.json(); })
  .then(function() {
    btn.textContent = '✓ Añadido al carrito';
    setTimeout(function() {
      btn.disabled = false;
      btn.textContent = 'Agregar pack al carrito';
    }, 2000);
    fetch('/cart.js')
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        var counter = document.querySelector('.cart-count, [data-cart-count], .cart-item-count');
        if (counter) counter.textContent = cart.item_count;
      });
  })
  .catch(function() {
    btn.disabled = false;
    btn.textContent = 'Error, inténtalo de nuevo';
  });
}

document.addEventListener('DOMContentLoaded', function() {
  var toggleBtn = document.getElementById('wholesale-toggle');
  if (toggleBtn) toggleBtn.addEventListener('click', wsToggle);
});